import { Vue, Component } from 'vue-property-decorator';

@Component({ functional: true })
export default class VrmValidation extends Vue {
    render(h, context) {
        console.log('vrm-validation', h, context);
        return h();
    }
}
